import React, { useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';


const MicroFrontendContainer = ({
    MicroFrontend,
    history,
    data,
    name,
    height,
    skeletonId,
    refresh,
    skeletonHeight = '100%',
    width = '100%',
    removeAbsolutePosition,
    className = '',
    containerPosition = 'relative',
    isSideNav,
    userState,
    zIndex = {},
    parentContainerClassName = ''
}) => {

    useEffect(() => {
        const backDrop = document.getElementsByClassName('modal-backdrop')[0];
        // remove show class from backdrop
        if (backDrop) {
            backDrop.classList.remove('show');
        }
    }, []);


    const position = removeAbsolutePosition ? 'relative' : 'absolute';

    const skeletonStyleContainer = {
        width,
        height,
        position,
    };


    return (
        <>
            <div className={parentContainerClassName} style={{ position: containerPosition, top: 0, ...zIndex }}>
                <div
                    id={skeletonId}
                    className={className}
                    style={skeletonStyleContainer}
                >
                    <Skeleton
                        className='skeleton'
                        height={skeletonHeight}
                        width="100%"
                    />
                </div>
                {!isSideNav && (
                    <MicroFrontend
                        refresh={refresh}
                        name={name}
                        history={history}
                        data={data}
                    />
                )}
            </div>
            {isSideNav && (
                <MicroFrontend
                    refresh={refresh}
                    name={name}
                    history={history}
                    data={data}
                />
            )}
        </>
    );
};

export default MicroFrontendContainer;
